// MRP (Material Requirements Planning) 系統資料模型
// MRP System Data Model

import { products, suppliers } from './inventoryData';
import { salesOrders } from './salesOrderData';
import { productionOrders } from './productionData';

// MRP 計劃狀態
export const mrpPlanStatuses = [
  {
    id: 'draft',
    name: '草稿',
    name_en: 'Draft',
    color: '#9CA3AF',
    icon: 'FileText'
  },
  {
    id: 'active',
    name: '執行中',
    name_en: 'Active',
    color: '#10B981',
    icon: 'Play'
  },
  {
    id: 'completed',
    name: '已完成',
    name_en: 'Completed',
    color: '#3B82F6',
    icon: 'CheckCircle'
  },
  {
    id: 'cancelled',
    name: '已取消',
    name_en: 'Cancelled',
    color: '#EF4444',
    icon: 'XCircle'
  }
];

// MRP 項目狀態
export const mrpItemStatuses = [
  {
    id: 'draft',
    name: '草稿',
    name_en: 'Draft',
    color: '#9CA3AF',
    icon: 'FileText'
  },
  {
    id: 'planned',
    name: '已計劃',
    name_en: 'Planned',
    color: '#8B5CF6',
    icon: 'Calendar'
  },
  {
    id: 'ordered',
    name: '已下單',
    name_en: 'Ordered',
    color: '#F59E0B',
    icon: 'ShoppingCart'
  },
  {
    id: 'received',
    name: '已收貨',
    name_en: 'Received',
    color: '#10B981',
    icon: 'Package'
  },
  {
    id: 'delayed',
    name: '延遲',
    name_en: 'Delayed',
    color: '#EF4444',
    icon: 'Clock'
  },
  {
    id: 'completed',
    name: '已完成',
    name_en: 'Completed',
    color: '#3B82F6',
    icon: 'CheckCircle'
  },
  {
    id: 'cancelled',
    name: '已取消',
    name_en: 'Cancelled',
    color: '#6B7280',
    icon: 'XCircle'
  }
];

// MRP 計劃頭檔
export const mrpPlans = [
  {
    id: 'mrp-2025-q1',
    name: '2025年第一季MRP計劃',
    name_en: '2025 Q1 MRP Plan',
    description: '2025年第一季物料需求計劃',
    status: 'active',
    planningPeriod: 'Q1-2025',
    startDate: '2025-01-01',
    endDate: '2025-03-31',
    createdBy: '王小明',
    createdAt: '2024-12-15T08:30:00',
    lastUpdatedAt: '2025-01-02T10:15:00',
    lastUpdatedBy: '王小明',
    notes: '根據銷售預測和生產計劃制定'
  },
  {
    id: 'mrp-2025-q2',
    name: '2025年第二季MRP計劃',
    name_en: '2025 Q2 MRP Plan',
    description: '2025年第二季物料需求計劃',
    status: 'draft',
    planningPeriod: 'Q2-2025',
    startDate: '2025-04-01',
    endDate: '2025-06-30',
    createdBy: '王小明',
    createdAt: '2025-01-15T14:20:00',
    lastUpdatedAt: '2025-01-15T14:20:00',
    lastUpdatedBy: '王小明',
    notes: '初步草案，等待確認'
  }
];

// MRP 計劃明細
export const mrpItems = [
  // 2025 Q1 MRP Items
  {
    id: 'mrp-item-001',
    planId: 'mrp-2025-q1',
    productId: 'prod-001',
    requiredQuantity: 5000,
    availableQuantity: 1200,
    onOrderQuantity: 1000,
    netRequirement: 2800,
    plannedOrderQuantity: 3000,
    plannedOrderDate: '2025-01-15',
    expectedReceiptDate: '2025-02-01',
    priority: 'high',
    status: 'planned',
    notes: '關鍵原料，需確保供應'
  },
  {
    id: 'mrp-item-002',
    planId: 'mrp-2025-q1',
    productId: 'prod-002',
    requiredQuantity: 3000,
    availableQuantity: 800,
    onOrderQuantity: 500,
    netRequirement: 1700,
    plannedOrderQuantity: 2000,
    plannedOrderDate: '2025-01-20',
    expectedReceiptDate: '2025-02-05',
    priority: 'medium',
    status: 'planned',
    notes: ''
  },
  {
    id: 'mrp-item-003',
    planId: 'mrp-2025-q1',
    productId: 'prod-005',
    requiredQuantity: 10000,
    availableQuantity: 2000,
    onOrderQuantity: 0,
    netRequirement: 8000,
    plannedOrderQuantity: 8000,
    plannedOrderDate: '2025-01-10',
    expectedReceiptDate: '2025-01-25',
    priority: 'critical',
    status: 'ordered',
    notes: '已下訂單，等待交貨'
  },
  {
    id: 'mrp-item-004',
    planId: 'mrp-2025-q1',
    productId: 'prod-008',
    requiredQuantity: 4000,
    availableQuantity: 1000,
    onOrderQuantity: 0,
    netRequirement: 3000,
    plannedOrderQuantity: 4000,
    plannedOrderDate: '2025-01-25',
    expectedReceiptDate: '2025-02-10',
    priority: 'medium',
    status: 'planned',
    notes: ''
  },
  // 2025 Q2 MRP Items (Draft)
  {
    id: 'mrp-item-005',
    planId: 'mrp-2025-q2',
    productId: 'prod-001',
    requiredQuantity: 6000,
    availableQuantity: 0,
    onOrderQuantity: 0,
    netRequirement: 6000,
    plannedOrderQuantity: 6000,
    plannedOrderDate: '2025-04-10',
    expectedReceiptDate: '2025-04-25',
    priority: 'medium',
    status: 'draft',
    notes: '預估需求，待確認'
  },
  {
    id: 'mrp-item-006',
    planId: 'mrp-2025-q2',
    productId: 'prod-002',
    requiredQuantity: 3500,
    availableQuantity: 0,
    onOrderQuantity: 0,
    netRequirement: 3500,
    plannedOrderQuantity: 4000,
    plannedOrderDate: '2025-04-15',
    expectedReceiptDate: '2025-05-01',
    priority: 'medium',
    status: 'draft',
    notes: '預估需求，待確認'
  }
];

// 需求預測
export const demandForecasts = [
  {
    id: 'forecast-2025-q1',
    name: '2025年第一季需求預測',
    period: 'Q1-2025',
    createdAt: '2024-12-01T09:00:00',
    createdBy: '李分析師',
    lastUpdatedAt: '2024-12-10T14:30:00',
    lastUpdatedBy: '李分析師',
    status: 'approved',
    approvedBy: '張經理',
    approvedAt: '2024-12-15T10:00:00',
    notes: '根據過去銷售數據和市場趨勢分析',
    productCategory: '辦公家具',
    productId: 'prod-010',
    totalQuantity: 1200,
    unit: '個',
    confidenceLevel: 85,
    trend: 'up'
  },
  {
    id: 'forecast-2025-q1-2',
    name: '2025年第一季需求預測',
    period: 'Q1-2025',
    createdAt: '2024-12-01T09:00:00',
    createdBy: '李分析師',
    lastUpdatedAt: '2024-12-10T14:30:00',
    lastUpdatedBy: '李分析師',
    status: 'approved',
    approvedBy: '張經理',
    approvedAt: '2024-12-15T10:00:00',
    notes: '根據過去銷售數據和市場趨勢分析',
    productCategory: '辦公家具',
    productId: 'prod-011',
    totalQuantity: 800,
    unit: '個',
    confidenceLevel: 80,
    trend: 'up'
  },
  {
    id: 'forecast-2025-q1-3',
    name: '2025年第一季需求預測',
    period: 'Q1-2025',
    createdAt: '2024-12-01T09:00:00',
    createdBy: '李分析師',
    lastUpdatedAt: '2024-12-10T14:30:00',
    lastUpdatedBy: '李分析師',
    status: 'approved',
    approvedBy: '張經理',
    approvedAt: '2024-12-15T10:00:00',
    notes: '根據過去銷售數據和市場趨勢分析',
    productCategory: '辦公用品',
    productId: 'prod-020',
    totalQuantity: 5000,
    unit: '個',
    confidenceLevel: 90,
    trend: 'stable'
  },
  {
    id: 'forecast-2025-q2',
    name: '2025年第二季需求預測',
    period: 'Q2-2025',
    createdAt: '2024-12-20T09:00:00',
    createdBy: '李分析師',
    lastUpdatedAt: '2024-12-28T11:15:00',
    lastUpdatedBy: '李分析師',
    status: 'draft',
    notes: '初步預測，等待市場調查報告',
    productCategory: '辦公家具',
    productId: 'prod-010',
    totalQuantity: 1500,
    unit: '個',
    confidenceLevel: 70,
    trend: 'up'
  },
  {
    id: 'forecast-2025-q2-2',
    name: '2025年第二季需求預測',
    period: 'Q2-2025',
    createdAt: '2024-12-20T09:00:00',
    createdBy: '李分析師',
    lastUpdatedAt: '2024-12-28T11:15:00',
    lastUpdatedBy: '李分析師',
    status: 'draft',
    notes: '初步預測，等待市場調查報告',
    productCategory: '辦公家具',
    productId: 'prod-011',
    totalQuantity: 1000,
    unit: '個',
    confidenceLevel: 65,
    trend: 'up'
  },
  {
    id: 'forecast-2025-q2-3',
    name: '2025年第二季需求預測',
    period: 'Q2-2025',
    createdAt: '2024-12-20T09:00:00',
    createdBy: '李分析師',
    lastUpdatedAt: '2024-12-28T11:15:00',
    lastUpdatedBy: '李分析師',
    status: 'draft',
    notes: '初步預測，等待市場調查報告',
    productCategory: '辦公用品',
    productId: 'prod-012',
    totalQuantity: 600,
    unit: '個',
    confidenceLevel: 60,
    trend: 'down'
  }
];

// 採購建議
export const purchaseSuggestions = [
  {
    id: 'ps-001',
    planId: 'mrp-2025-q1',
    productId: 'prod-001',
    suggestedQuantity: 3000,
    suggestedOrderDate: '2025-01-15',
    suggestedSupplierId: 'sup-001',
    alternativeSuppliers: ['sup-003', 'sup-004'],
    urgency: 'high',
    reason: '庫存低於安全水位，需及時補充',
    status: 'approved',
    createdAt: '2025-01-02T08:30:00',
    createdBy: '系統',
    approvedAt: '2025-01-02T10:15:00',
    approvedBy: '張採購'
  },
  {
    id: 'ps-002',
    planId: 'mrp-2025-q1',
    productId: 'prod-005',
    suggestedQuantity: 8000,
    suggestedOrderDate: '2025-01-10',
    suggestedSupplierId: 'sup-002',
    alternativeSuppliers: [],
    urgency: 'critical',
    reason: '關鍵零件，庫存嚴重不足',
    status: 'approved',
    createdAt: '2025-01-02T08:30:00',
    createdBy: '系統',
    approvedAt: '2025-01-02T10:15:00',
    approvedBy: '張採購'
  },
  {
    id: 'ps-003',
    planId: 'mrp-2025-q1',
    productId: 'prod-008',
    suggestedQuantity: 4000,
    suggestedOrderDate: '2025-01-20',
    suggestedSupplierId: 'sup-002',
    alternativeSuppliers: ['sup-005'],
    urgency: 'medium',
    reason: '預期需求增加，現有庫存不足',
    status: 'pending',
    createdAt: '2025-01-02T08:30:00',
    createdBy: '系統'
  }
];

// 物料清單 (BOM)
export const billOfMaterials = [
  {
    bom_id: 'bom-001',
    productId: 'prod-010', // 成品：高級辦公椅
    product_code: 'FP-001',
    description: '高階辦公椅',
    category: '家具',
    version: '1.0',
    effectiveDate: '2024-01-01',
    components: [
      { 
        component_code: 'RM-001',
        componentId: 'prod-001', 
        description: '椅架骨架',
        quantity: 2.5, 
        unit: '公斤', 
        cost: 120.50
      },
      { 
        component_code: 'RM-002',
        componentId: 'prod-005', 
        description: '組裝用螺絲',
        quantity: 12, 
        unit: '個', 
        cost: 5.25
      },
      { 
        component_code: 'RM-003',
        componentId: 'prod-006', 
        description: '椅背外殼',
        quantity: 1, 
        unit: '個', 
        cost: 35.00
      },
      { 
        component_code: 'RM-004',
        componentId: 'prod-007', 
        description: '座墊',
        quantity: 1, 
        unit: '個', 
        cost: 45.00
      },
      { 
        component_code: 'RM-005',
        componentId: 'prod-008', 
        description: '包裝盒',
        quantity: 1, 
        unit: '個', 
        cost: 15.00
      }
    ]
  },
  {
    bom_id: 'bom-002',
    productId: 'prod-011', // 成品：標準辦公椅
    product_code: 'FP-002',
    description: '標準辦公椅',
    category: '家具',
    version: '2.1',
    effectiveDate: '2024-03-15',
    components: [
      { 
        component_code: 'RM-006',
        componentId: 'prod-001', 
        description: '椅架骨架',
        quantity: 2, 
        unit: '公斤', 
        cost: 100.00
      },
      { 
        component_code: 'RM-007',
        componentId: 'prod-005', 
        description: '組裝用螺絲',
        quantity: 8, 
        unit: '個', 
        cost: 4.00
      },
      { 
        component_code: 'RM-008',
        componentId: 'prod-006', 
        description: '椅背外殼',
        quantity: 1, 
        unit: '個', 
        cost: 30.00
      },
      { 
        component_code: 'RM-009',
        componentId: 'prod-007', 
        description: '座墊',
        quantity: 1, 
        unit: '個', 
        cost: 35.00
      },
      { 
        component_code: 'RM-010',
        componentId: 'prod-008', 
        description: '包裝盒',
        quantity: 1, 
        unit: '個', 
        cost: 10.00
      }
    ]
  },
  {
    bom_id: 'bom-003',
    product_code: 'FP-003',
    description: '文件櫃',
    category: '儲存',
    version: '1.0',
    effective_date: '2024-01-01',
    components: [
      {
        component_code: 'RM-009',
        description: '櫃體',
        quantity: 1,
        unit: '個',
        cost: 85.00
      },
      {
        component_code: 'RM-010',
        description: '抽屜',
        quantity: 3,
        unit: '個',
        cost: 25.00
      },
      {
        component_code: 'RM-011',
        description: '把手',
        quantity: 3,
        unit: '個',
        cost: 5.00
      },
      {
        component_code: 'RM-012',
        description: '滑軌',
        quantity: 6,
        unit: '支',
        cost: 8.00
      }
    ]
  }
];

// MRP 執行日誌
export const mrpExecutionLogs = [
  {
    id: 'log-001',
    planId: 'mrp-2025-q1',
    executionDate: '2025-01-02T08:30:00',
    executionBy: '系統',
    status: 'completed',
    duration: 120, // seconds
    itemsProcessed: 4,
    suggestionsGenerated: 3,
    errors: [],
    warnings: ['產品 prod-005 庫存低於安全水位']
  },
  {
    id: 'log-002',
    planId: 'mrp-2025-q2',
    executionDate: '2025-01-15T14:20:00',
    executionBy: '王小明',
    status: 'completed',
    duration: 95, // seconds
    itemsProcessed: 2,
    suggestionsGenerated: 0,
    errors: [],
    warnings: []
  }
];
